// ── StarRating ────────────────────────────────────────────────────────────────
// Read-only display of a 1–5 star rating.

type StarRatingProps = {
  rating: number;
};

export function StarRating({ rating }: StarRatingProps): React.ReactNode {
  return (
    <div className="flex gap-0.5">
      {Array.from({ length: 5 }, (_, i) => (
        <span key={i} className={i < rating ? 'text-amber-400' : 'text-muted-foreground/30'}>
          ★
        </span>
      ))}
    </div>
  );
}

// ── StarRatingInput ───────────────────────────────────────────────────────────
// Interactive star selector. Clicking the current rating deselects it (sets null).

type StarRatingInputProps = {
  value: number | null;
  onChange: (value: number | null) => void;
  size?: 'sm' | 'md';
};

export function StarRatingInput({
  value,
  onChange,
  size = 'md'
}: StarRatingInputProps): React.ReactNode {
  return (
    <div className="flex gap-0.5">
      {Array.from({ length: 5 }, (_, i) => {
        const star = i + 1;
        return (
          <button
            key={star}
            type="button"
            className={`transition-colors ${size === 'sm' ? 'text-lg' : 'text-xl'} ${
              star <= (value ?? 0)
                ? 'text-amber-400'
                : 'text-muted-foreground/30 hover:text-amber-300'
            }`}
            onClick={() => {
              onChange(value === star ? null : star);
            }}
          >
            ★
          </button>
        );
      })}
    </div>
  );
}
